import TranslationsActions from './TranslationsActions';
import NavigationActions from './NavigationActions';
import DebugActions from './DebugActions';
import LocationsActions from './LocationsActions';
import ExperiencesActions from './ExperiencesActions';
import FiltersActions from './FiltersActions';
import SearchActions from './SearchActions';
import ExperienceFilterActions from './ExperienceFilterActions';
import BookingActions from './BookingActions';
import OfferRequestActions from './OfferRequestActions';
import { SearchMode, Filter } from 'model/Filters';
import { AVAILABILITY_FILTER_OPTIONS } from 'data/subOptions/availabilitySubOptions';

export interface FiltersActionsInterface {
  setGuests(guests: { nrOfAdults: number; nrOfChildren: number }): void;
  setLocation(location: { country: string; city: string }): void;
  setSearchMode(mode: SearchMode): void;
  setFilters(filters: { country?: string; city?: string; activeFilters: Filter[]; page?: number }): void;
  flushFilters(): void;
  setDates(dates: { selectedFrom: string; selectedTo: string }): void;
  setAvailabilityFilter(availability: { availability: AVAILABILITY_FILTER_OPTIONS }): void;
  resetDates(): void;
  setFilterLang(lang: string);
}

export interface ExperienceFilterActionsInterface {
  setGuests(guests: { nrOfAdults: number; nrOfChildren: number }): void;
  setDateTime(dateTime: { date: string; time: string }): void;
  setDate(value: { date: string }): void;
  setTime(value: { time: string }): void;
  setLanguages(value: { languages: string[] }): void;
  setSelectedHost(value: { host: any }): void;
  resetStore(): void;
}

export default function (flux) {
  flux.addActions(NavigationActions);
  flux.addActions(DebugActions);
  flux.addActions(TranslationsActions);
  flux.addActions(LocationsActions);
  flux.addActions(ExperiencesActions);
  flux.addActions(FiltersActions);
  flux.addActions(SearchActions);
  flux.addActions(ExperienceFilterActions);
  flux.addActions(BookingActions);
  flux.addActions(OfferRequestActions);
}
